import svg from './row-svg/geoportail-v3.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function GeoportailV3Icon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default GeoportailV3Icon;
